<template>
  <div class="card card-rounded card-shadow border-0 mb-3 icon-watermark-top card-with-watermark">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="font-weight-bolder">{{ $t('RepaymentBalance.yourRepaymentBalance') }}</div>
        <div class="h4 text-body line-height-1 my-0">{{ $n(balance.amount, 'currencyNoDecimals') }}</div>
      </div>
    </div>
    <Icon icon-name="money-outline" icon-class="icon-watermark"></Icon>
  </div>
</template>

<script>

import Icon from '@shared/components/Icon'

export default {
  components: {
    Icon
  },
  props: ['balance']
}
</script>
